(() => {
  const dialog = document.querySelector('[data-private-offer-dialog]');
  if (!dialog || typeof dialog.showModal !== 'function') return;

  const image = dialog.querySelector('[data-private-offer-image]');
  const artist = dialog.querySelector('[data-private-offer-artist]');
  const title = dialog.querySelector('[data-private-offer-title]');
  const subject = dialog.querySelector('[data-private-offer-subject]');
  const productIdField = dialog.querySelector('[data-private-offer-product-id]');
  const hiddenTitle = dialog.querySelector('[data-private-offer-hidden-title]');
  const hiddenArtist = dialog.querySelector('[data-private-offer-hidden-artist]');
  const hiddenPrice = dialog.querySelector('[data-private-offer-hidden-price]');
  const form = dialog.querySelector('form');
  const amountInput = dialog.querySelector('[data-private-offer-amount]');
  const amountError = dialog.querySelector('[data-private-offer-amount-error]');

  // Offers may not fall below the acquisition threshold for the work. The threshold
  // is stored in cents, computed per variant in the trigger snippet, and is never shown.
  let minimumOfferCents = 0;

  const showAmountError = (show) => {
    if (!amountInput || !amountError) return;
    amountError.hidden = !show;
    amountError.textContent = show
      ? 'This offer is below the acceptable threshold for this work. Please revise the amount to continue.'
      : '';
    amountInput.setAttribute('aria-invalid', show ? 'true' : 'false');
  };

  const isBelowMinimum = () => {
    if (!amountInput || amountInput.value === '' || !minimumOfferCents) return false;
    const amount = Number(amountInput.value);
    return Number.isFinite(amount) && amount < minimumOfferCents / 100;
  };

  const validateAmount = () => {
    const below = isBelowMinimum();
    showAmountError(below);
    return !below;
  };

  const finishClose = () => {
    if (!dialog.open || dialog.dataset.closing !== 'true') return;
    dialog.close();
    delete dialog.dataset.closing;
  };

  const closeDialog = () => {
    if (!dialog.open || dialog.dataset.closing === 'true') return;
    dialog.dataset.closing = 'true';
    window.setTimeout(finishClose, 400);
  };

  const setArtwork = (trigger) => {
    const artworkTitle = trigger.dataset.productTitle || '';
    const artworkArtist = trigger.dataset.productArtist || '';
    const artworkPrice = trigger.dataset.productPrice || '';
    const productId = trigger.dataset.productId || '';
    const imageUrl = trigger.dataset.productImage || '';

    title.textContent = artworkTitle;
    artist.textContent = artworkArtist;
    artist.hidden = !artworkArtist;

    if (imageUrl) {
      image.src = imageUrl;
      image.alt = trigger.dataset.productImageAlt || (artworkArtist ? `${artworkTitle} by ${artworkArtist}` : artworkTitle);
      image.hidden = false;
    } else {
      image.removeAttribute('src');
      image.alt = '';
      image.hidden = true;
    }

    minimumOfferCents = Number(trigger.dataset.productMinOfferCents) || 0;
    if (amountInput) {
      amountInput.min = minimumOfferCents ? (minimumOfferCents / 100).toFixed(2) : '0.01';
    }
    if (amountInput && amountInput.value) validateAmount();
    else showAmountError(false);

    subject.value = `Private Offer: ${artworkTitle}`;
    productIdField.value = productId;
    hiddenTitle.value = artworkTitle;
    hiddenArtist.value = artworkArtist;
    hiddenPrice.value = artworkPrice;

    const returnTo = form.querySelector('[name="return_to"]');
    if (returnTo) {
      const target = new URL(window.location.href);
      target.searchParams.set('contact_posted', 'true');
      target.searchParams.set('private_offer_product_id', productId);
      target.hash = 'cs-private-offer-dialog';
      returnTo.value = `${target.pathname}${target.search}${target.hash}`;
    }
  };

  const openDialog = (trigger) => {
    setArtwork(trigger);
    delete dialog.dataset.closing;
    if (!dialog.open) dialog.showModal();

    window.requestAnimationFrame(() => {
      const status = dialog.querySelector('[data-private-offer-status]');
      const firstField = dialog.querySelector('[autofocus]');
      (status || firstField || dialog.querySelector('[data-private-offer-close]'))?.focus();
    });
  };

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-private-offer-trigger]');
    if (trigger) {
      event.preventDefault();
      openDialog(trigger);
      return;
    }

    if (event.target.closest('[data-private-offer-close]')) closeDialog();
  });

  if (amountInput) {
    amountInput.addEventListener('input', validateAmount);
    amountInput.addEventListener('change', validateAmount);
    // Suppress the browser bubble for a low amount and show the discreet notice instead.
    amountInput.addEventListener('invalid', (event) => {
      if (!isBelowMinimum()) return;
      event.preventDefault();
      validateAmount();
    });
  }

  form?.addEventListener('submit', (event) => {
    if (validateAmount()) return;
    event.preventDefault();
    amountInput?.focus();
  });

  dialog.addEventListener('cancel', (event) => {
    event.preventDefault();
    closeDialog();
  });

  dialog.addEventListener('click', (event) => {
    if (event.target !== dialog) return;
    const bounds = dialog.getBoundingClientRect();
    if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) {
      closeDialog();
    }
  });

  dialog.addEventListener('animationend', (event) => {
    if (event.target === dialog && dialog.dataset.closing === 'true') finishClose();
  });

  const reopenedProductId = new URLSearchParams(window.location.search).get('private_offer_product_id');
  if (reopenedProductId) {
    const trigger = Array.from(document.querySelectorAll('[data-private-offer-trigger]')).find((button) => button.dataset.productId === reopenedProductId);
    if (trigger) openDialog(trigger);

    const target = new URL(window.location.href);
    target.searchParams.delete('private_offer_product_id');
    window.history.replaceState({}, '', `${target.pathname}${target.search}${target.hash}`);
  }
})();
